._container_17dcs_1 {
  background: var(--chat-message-ai-bg-color); }

._text_17dcs_4 {
  color: var(--text-color) !important; }

._icon_17dcs_7 {
  fill: #000624;
  margin-right: 10px; }
